import { useSuspenseQuery, UseSuspenseQueryOptions } from "@tanstack/react-query";
import { Collection, Project } from "@/types";
import { api, ErrorResponse } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

export const useProjects = (
  options: Omit<UseSuspenseQueryOptions<unknown, ErrorResponse, Collection<Project>>, "queryKey"> = {}
) => {
  return useSuspenseQuery<unknown, ErrorResponse, Collection<Project>>({
    queryKey: ["projects"],
    queryFn: async (): Promise<Collection<Project>> => {
      const response = await api.get<Collection<Project>>("/projects");
      return camelize(response.data);
    },
    ...options
  });
};
